/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskGlassdoorReview } from './ExecRiskGlassdoorReview';
import {
    ExecRiskGlassdoorReviewFromJSON,
    ExecRiskGlassdoorReviewFromJSONTyped,
    ExecRiskGlassdoorReviewToJSON,
} from './ExecRiskGlassdoorReview';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedGlassDoorReviewsResponse
 */
export interface ExecRiskPaginatedGlassDoorReviewsResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorReviewsResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskGlassdoorReview>}
     * @memberof ExecRiskPaginatedGlassDoorReviewsResponse
     */
    results: Array<ExecRiskGlassdoorReview>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedGlassDoorReviewsResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorReviewsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorReviewsResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedGlassDoorReviewsResponse interface.
 */
export function instanceOfExecRiskPaginatedGlassDoorReviewsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedGlassDoorReviewsResponseFromJSON(json: any): ExecRiskPaginatedGlassDoorReviewsResponse {
    return ExecRiskPaginatedGlassDoorReviewsResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedGlassDoorReviewsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedGlassDoorReviewsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskGlassdoorReviewFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedGlassDoorReviewsResponseToJSON(value?: ExecRiskPaginatedGlassDoorReviewsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskGlassdoorReviewToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

